module.exports = __webpack_public_path__ + "static/media/blog.f3ddab4c.svg";